import { SetStateAction } from 'react';

import { Field } from 'coreOld/components';
import { Checkbox, ErrorMessage, Grid } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';

import { Hidden } from './rangeFilterStyle';

interface IProps {
  fromValue: string;
  toValue: string;
  setToValue: React.Dispatch<SetStateAction<string>>;
  setFromValue: React.Dispatch<SetStateAction<string>>;
  checkboxProps?: Record<string, any>;
  checkboxValue?: string;
  onCheckboxClick?: (event) => void;
  error?: string;
}

const RangeFilterView = ({
  fromValue,
  toValue,
  setFromValue,
  setToValue,
  checkboxProps,
  checkboxValue,
  onCheckboxClick,
  error,
}: IProps) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <Field
          type={InputType.TEXTFIELD}
          inputProps={{
            placeholder: 'From',
            type: 'number',
            value: fromValue,
            size: Size.MD,
            disabled: Boolean(checkboxValue),
            isEditable: Boolean(checkboxValue),
            onChange: (event) => setFromValue(event.target.value),
            error: Boolean(error),
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <Field
          type={InputType.TEXTFIELD}
          inputProps={{
            placeholder: 'To',
            type: 'number',
            value: toValue,
            size: Size.MD,
            disabled: Boolean(checkboxValue),
            isEditable: Boolean(checkboxValue),
            onChange: (event) => setToValue(event.target.value),
            error: Boolean(error),
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <Hidden isHidden={!checkboxProps}>
          <Checkbox
            label={checkboxProps?.label}
            value={checkboxProps?.value}
            defaultChecked={Boolean(checkboxValue)}
            checked={Boolean(checkboxValue)}
            onChange={(event) => onCheckboxClick(event)}
          />
        </Hidden>
      </Grid>

      <ErrorMessage>{error}</ErrorMessage>
    </Grid>
  );
};

export default RangeFilterView;
